import { LoadingScreen } from "@/components/layout/Loading";
import PersonalTabs from "@/components/pages/customers/personal/personal-tabs";
import { useAuth } from "@/contexts/auth-context";
import { getRegistrationData } from "@/services/clientAreaService";
import { ClientAddress } from "@/types/ClientAddress";
import { RegistrationData } from "@/types/RegistrationData";
import { Veiculo } from "@/types/Veiculo";
import { useEffect, useState } from "react";
import NewQuoteCard from "../../../components/pages/client/cards/new-quote-card";

export default function PersonalDataPage() {
  const { user } = useAuth();
  const cliCodigo = user?.cli_codigo;

  const [vehicles, setVehicles] = useState<Veiculo[]>([]);
  const [addresses, setAddresses] = useState<ClientAddress[]>([]);
  const [registrationData, setRegistrationData] =
    useState<RegistrationData | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!cliCodigo) return;

    const fetchData = async () => {
      try {
        const data: RegistrationData = await getRegistrationData(cliCodigo);
        setRegistrationData(data);
        setVehicles(data.veiculos);
        setAddresses(data.enderecos);
      } catch (error) {
        console.error("Erro ao buscar dados cadastrais:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [cliCodigo]);

  if (loading) {
    return <LoadingScreen />;
  }

  return (
    <div className="py-6 sm:py-10 w-full max-w-7xl mx-auto">
      <h1 className="text-2xl sm:text-3xl font-bold text-n-green mb-5">
        Meus dados cadastrais
      </h1>

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
        <div className="lg:col-span-8 flex flex-col gap-6">
          <div className="space-y-4 rounded-2xl bg-white px-3 py-4 sm:px-8 sm:py-6 shadow-sm">
            <PersonalTabs
              vehicles={vehicles}
              addresses={addresses}
              registrationData={registrationData}
            />
          </div>
        </div>

        <div className="lg:col-span-4 flex flex-col gap-4">
          <NewQuoteCard
            onClick={() => window.open("/fazer-cotacao", "_blank")}
          />
        </div>
      </div>
    </div>
  );
}
